
export default {
  props: {
    results: {
      type: [Object],
      default: () => ({}),
    },
  },

  computed: {
    saveMoney() {
      return this.results?.saveMoney?.years || [];
    },

    ruleOneMoney() {
      return this.results?.ruleOneMoney?.years || [];
    },

    currentAge() {
      return Number(this.results.currentAge || 0);
    },

    savingInterest() {
      return this.results.interest;
    },

    ruleOneInterest() {
      return this.results.ruleOneInterest;
    },

    yourNumberYears() {
      return this.results.yourNumber?.costYears || [];
    },

    yourNumberChart() {
      const value = this.yourNumberYears.map((item) => {
        const currentKey = item.key;
        const costs = this.yourNumberYears.filter(
          (condition) => condition.key <= currentKey
        );
        const totalCost = costs.reduce((sum, record) => sum + record.value, 0);

        return totalCost;
      });

      return value;
    },

    saveMoneyChart() {
      const data = this.saveMoney.map((item) => item.value);

      return data;
    },

    ruleOneMoneyChart() {
      const data = this.ruleOneMoney.map((item) => ({
        label: `Tổng tiền kiếm được với lãi suất ${this.ruleOneInterest} % năm`,
        name: `${Number(item.key) + Number(this.currentAge)} tuổi`,
        value: {
          x: `${Number(item.key) + Number(this.currentAge)} tuổi`,
          y: item.value,
        },
        color: 'purple',
        borderColor: 'purple',
        borderWidth: 1,
      }));

      return data;
    },

    chartReport() {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'line',
          height: 600,
        },
        title: {
          text: null,
          style: {
            display: 'none',
          },
        },
        plotOptions: {
          series: {
            pointWidth: 10,
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: 'Tổng chi phí bạn cần',
            data: this.yourNumberChart,
          },
          {
            name: 'Tổng tiền kiếm được với lãi suất',
            data: this.saveMoneyChart,
          },
        ],
      };
    },
  },
};
